<template>
    <div class="bi-container" :style="'height:'+wheight+'px'">
        <div class="bp" >
            <img src="./images/bp-2023.png">
        </div>
        <div class="yh" >
            <img src="./images/yh.png">
        </div>
        <div class="inn">
<!--            <div class="yd">-->
<!--                <img src="./images/yd.png">-->
<!--            </div>-->
            <!--<div class="bival">
                <img src="./images/bival.png">
            </div>-->
            <div class="bi-sale" v-if="biVal">
                <div class="bi-text"><span class="bi-counter">{{biVal}}</span><span class="text">亿</span></div>
                <div class="bi-text-shadow"><span class="bi-counter">{{biVal}}</span><span class="text">亿</span></div>
            </div>
            <div class="timebox-c">{{currentTime}}</div>
        </div>

        <div class="logo-c">
            <img src="./images/logo-cec.png">
        </div>
    </div>
</template>

<script>
    import './bi-newyear.css';
    import axios from 'axios';
    import countTo from "vue-count-to";

    export default {
        name: "index",
        components: {countTo},
        data() {
            return {
                weight: document.documentElement.clientWidth,
                wheight: document.documentElement.clientHeight,
                currentTime: this.Common.formatDateTimeDigital(new Date(2022,11,31,15,0,0)),
                biVal:0,
                timer:null
            }
        },
        mounted() {
            this.changeTime();
            this.getBIStatistical();
            this.timer = setInterval(()=>{
                this.getBIStatistical();
            },50*1000)
        },

        methods:{
            changeTime(){
                let endTime = new Date()
                endTime.setFullYear(2023, 11, 31)
                endTime.setHours(15,0,0);
                let timer = null;
                timer = setInterval(()=>{
                    if(endTime.getTime() <=  new Date().getTime()){
                        this.currentTime = this.Common.formatDateTimeDigital(endTime)
                        clearInterval(timer)
                        timer = null
                    }else{
                        this.currentTime = this.Common.formatDateTimeDigital(new Date())
                    }
                },1000)
            },
            getLastDay() {
                var today = new Date();
                var then = new Date();
                then.setFullYear(2023, 11, 31)
                var diff = then.getTime() - today.getTime();
                if(diff>=0){
                    diff = Math.floor(diff / (1000 * 60 * 60 * 24));
                }else{
                    diff =0;
                }
                this.lastday = diff
            },

            // 获取bi的年度业绩
            getBIStatistical(){
                let json_data = {};
                axios.post(this.CoreNew.OA_API_IP+"joa-crm/crm/mobile/biStatisticalquery",json_data,{
                    headers: {'Authorization':JSON.parse(localStorage.getItem('LS_ADMIN_USER_AUTHORIZATION'))}
                }).then(function (response) {
                    if (response.data.flag) {
                        let _data = response.data.data[0];
                        this.biVal = this.Common.formatNumber(_data.YEAR_AMT,2,0);
                        this.todayCounter = Number(this.Common.formatNumber(_data.TODAY_AMT,2,0));
                    }

                }.bind(this)).catch(function (error) {
                    // this.makeError(JSON.parse(localStorage.getItem('LS_ADMIN_USER_NAME')),"请求--bi--失败"+error);//记录错误
                    console.log("请求--bi--失败"+error);
                });
            },
        }
    }
</script>

<style scoped>
</style>